import React, { ReactElement } from "react";
import { makeStyles } from "@material-ui/core";
import ButtonBase from "@material-ui/core/Button";
import { ButtonBaseProps } from "@material-ui/core/ButtonBase/ButtonBase";

export interface ViewModeButtonProps extends ButtonBaseProps {
  onClick: () => void;
  startIcon: ReactElement;
  text: string;
}

const useStyles = makeStyles({
  root: {
    fontSize: "0.875rem",
    minWidth: "148px",
  },
  icon: {
    fontSize: "large",
    marginRight: "10px",
  },
  button: {
    height: 42,
  },
  span: {
    fontFamily: "Proxima Nova",
  },
});

const ViewModeButton: React.FC<ViewModeButtonProps> = (props) => {
  const classes = useStyles(props);
  const { onClick, text, style, className, startIcon } = props;

  return (
    <ButtonBase className={[classes.root, className].join(" ")} disableRipple onClick={onClick} style={style}>
      {startIcon}
      <span className={classes.span}>{text}</span>
    </ButtonBase>
  );
};

export default ViewModeButton;
